import { Injectable } from '@angular/core';

export interface ThemeColor { primaryColor?: string; secondaryColor?: string }

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor() {}

  private readonly MEDIUM_COLOR_PERCENT = 20
  private readonly LIGHT_COLOR_PERCENT = 40

  setTheme(themeColor: ThemeColor): void {
    if (!themeColor?.primaryColor || !themeColor?.secondaryColor) return;

    const primary = themeColor.primaryColor;
    const secondary = themeColor.secondaryColor;

    document.documentElement.style.setProperty('--humehealth-primary-color', primary);
    document.documentElement.style.setProperty('--humehealth-medium-primary-color', this.lightenHexColor(primary, this.MEDIUM_COLOR_PERCENT));
    document.documentElement.style.setProperty('--humehealth-light-primary-color', this.lightenHexColor(primary, this.LIGHT_COLOR_PERCENT));

    document.documentElement.style.setProperty('--humehealth-secondary-color', secondary);
    document.documentElement.style.setProperty('--humehealth-medium-secondary-color', this.lightenHexColor(secondary, this.MEDIUM_COLOR_PERCENT));
    document.documentElement.style.setProperty('--humehealth-light-secondary-color', this.lightenHexColor(secondary, this.LIGHT_COLOR_PERCENT));
  }

  private lightenHexColor(hex: string, percent: number): string {
    const num = parseInt(hex.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent);

    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00ff) + amt;
    const B = (num & 0x0000ff) + amt;

    return ('#' + (0x1000000 +
        (R < 255 ? (R < 0 ? 0 : R) : 255) * 0x10000 +
        (G < 255 ? (G < 0 ? 0 : G) : 255) * 0x100 +
        (B < 255 ? (B < 0 ? 0 : B) : 255)
      ).toString(16).slice(1))
  }
}
